"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var filterItems = function filterItems(items, searchTerm) {
  if (!items) {
    return [];
  }
  var filteredItems = [];
  items.forEach(function (item) {
    var found = item.label.toLowerCase().startsWith(searchTerm.toLowerCase());
    if (!found && item.items) {
      var filteredChildren = filterItems(item.items, searchTerm);
      if (filteredChildren.length > 0) {
        var filteredItem = Object.assign({}, item);
        filteredItem.items = filteredChildren;
        filteredItems.push(filteredItem);
        return;
      }
    }
    return found && filteredItems.push(item);
  });
  return filteredItems;
};

/*
 Convert a list of options into a function that filters and returns a resolved promise.
 This allows us to always treat options as an async filtering function.
 */
var createAsyncFilter = function createAsyncFilter(items) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return _react["default"].useCallback(function (searchTerm) {
    return Promise.resolve({
      items: filterItems(items, searchTerm)
    });
  }, [items]);
};
var _default = createAsyncFilter;
exports["default"] = _default;